import { useState, useEffect } from "react";
import { useAdmin } from "@/contexts/AdminContext";
import { Mail, Calendar } from "lucide-react";

export default function AdminContacts() {
  const { api } = useAdmin();
  const [contacts, setContacts] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    api.get("/admin/contacts").then(r => setContacts(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-contacts">
      <h1 className="font-heading text-2xl text-[#0A1628] font-medium mb-8">Contact Submissions</h1>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-1 space-y-2 max-h-[70vh] overflow-y-auto">
          {contacts.map(c => (
            <button key={c.id} onClick={() => setSelected(c)} data-testid={`contact-item-${c.id}`} className={`w-full text-left bg-white border p-4 rounded-[2px] hover:border-[#0A1628] transition-colors ${selected?.id === c.id ? "border-[#0A1628]" : "border-slate-200"}`}>
              <p className="text-[#0A1628] text-sm font-medium">{c.name}</p>
              <p className="text-slate-400 text-xs">{c.subject}</p>
              <p className="text-slate-300 text-[10px] mt-1">{new Date(c.created_at).toLocaleDateString()}</p>
            </button>
          ))}
          {contacts.length === 0 && <p className="text-slate-400 text-sm text-center py-8">No submissions yet.</p>}
        </div>
        <div className="lg:col-span-2">
          {selected ? (
            <div className="bg-white border border-slate-200 p-6 rounded-[2px]">
              <div className="flex items-center justify-between mb-6">
                <h2 className="font-heading text-xl text-[#0A1628] font-medium">{selected.name}</h2>
                <span className="text-xs text-slate-400 flex items-center gap-1"><Calendar size={12} /> {new Date(selected.created_at).toLocaleString()}</span>
              </div>
              <div className="grid grid-cols-2 gap-4 mb-6">
                <div><span className="text-xs text-slate-400 block">Email</span><a href={`mailto:${selected.email}`} className="text-sm text-[#0A1628] hover:text-[#C5A059]">{selected.email}</a></div>
                <div><span className="text-xs text-slate-400 block">Phone</span><p className="text-sm text-[#0A1628]">{selected.phone || "N/A"}</p></div>
                <div><span className="text-xs text-slate-400 block">Company</span><p className="text-sm text-[#0A1628]">{selected.company || "N/A"}</p></div>
                <div><span className="text-xs text-slate-400 block">Subject</span><p className="text-sm text-[#0A1628]">{selected.subject}</p></div>
              </div>
              <div><span className="text-xs text-slate-400 block mb-2">Message</span><p className="text-sm text-slate-600 leading-relaxed bg-slate-50 p-4 rounded-[2px]">{selected.message}</p></div>
            </div>
          ) : (
            <div className="flex items-center justify-center h-64 bg-white border border-slate-200 rounded-[2px]">
              <div className="text-center"><Mail size={32} className="text-slate-200 mx-auto mb-2" /><p className="text-slate-400 text-sm">Select a submission to view</p></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
